import React from 'react';
import {submit, isSubmitting} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';
import {CreateOfflinePeriodForm, Buttons} from './components';

import {MODALS} from 'ducks/allocations';

import './styles.css';

class CreateOfflinePeriodModal extends React.Component<any> {
  triggerSubmit = () => this.props.submit('createOfflinePeriod');

  render() {
    const {closeModal, data: {form: {submitting}, locationRef}} = this.props;
    return (
      <Modal
        modalOverlayClassName="CreateOfflinePeriodModalOverlay"
        className="CreateOfflinePeriodModal"
        show={true}
        type={Modal.EXTRA_SMALL}
        onClose={closeModal}>
        <Modal.Header heading="Create Out of Order Period" />
        <Modal.Body>
          <CreateOfflinePeriodForm locationRef={locationRef} />
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            submitting={submitting}
            triggerSubmit={this.triggerSubmit}
            closeModal={closeModal}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToModalData = state => {
  return {
    form: {
      submitting: isSubmitting('createOfflinePeriod')(state)
    }
  };
};

const mapDispatchToProps = {
  submit
};

export default withModal(
  MODALS.CREATE_OFFLINE_PERIOD,
  mapStateToModalData,
  mapDispatchToProps
)(CreateOfflinePeriodModal);
